/*
This file is located in the main branch
Last time the file was updated (UTC): [11.12.2024 08:50:34]
Permissions to update outside the main branch: [false]
*/

import {
    DropDown,
    DynamicListAddButton,
    DynamicListWrapperProps,
    requiredRule,
    ValidatedDropDownList,
    ValidatedDynamicListFormComponentProps,
    ValidatedInput,
} from '@finbeat/react-toolkit';
import { Trans, useTranslation } from 'react-i18next';
import { Table } from 'reactstrap';
import { TradeOrgAddForm } from './TradeOrgChangeModal';

const TradeOrgSettingsFormWrapper = ({ children, ...props }: DynamicListWrapperProps) => {
    return (
        <Table bordered>
            <thead>
                <tr className="align-middle">
                    <th className="w-45">
                        <Trans i18nKey="BackOfficeSettingType" />
                    </th>
                    <th className="w-45">
                        <Trans i18nKey="BackOfficeValue" />
                    </th>
                    <th className="w-10 text-center">
                        <DynamicListAddButton {...props} />
                    </th>
                </tr>
            </thead>
            <tbody>{children}</tbody>
        </Table>
    );
};

const TradeOrgSettingsForm = ({
    settingTypes,
    settingTypesFetching,
    formHasRole,
    idx,
    checkDouble,
    fieldId,
}: ValidatedDynamicListFormComponentProps & {
    settingTypes: DropDown[];
    settingTypesFetching: boolean;
    formHasRole: boolean;
}) => {
    const { t } = useTranslation();

    return (
        <>
            <td>
                <ValidatedDropDownList<TradeOrgAddForm>
                    label={t('BackOfficeSettingType')}
                    isClearable={false}
                    name={`settings.list.${idx}.type`}
                    items={settingTypes}
                    disabled={!formHasRole}
                    isLoading={settingTypesFetching}
                    rules={{
                        required: requiredRule,
                        validate: () => checkDouble(fieldId) ?? undefined,
                    }}
                />
            </td>
            <td>
                <ValidatedInput<TradeOrgAddForm>
                    name={`settings.list.${idx}.value`}
                    label={t('BackOfficeValue')}
                    disabled={!formHasRole}
                    rules={{
                        required: requiredRule,
                    }}
                />
            </td>
        </>
    );
};

export { TradeOrgSettingsForm, TradeOrgSettingsFormWrapper };
